
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host([site='GHS']) :host([height-grow]) {
    display:block;
}
  :host([site='GHS']) :host([height-grow]) {
    height:100%;
}
  :host([site='GHS']) :host([height-grow]) .card, :host([site='GHS']) :host([height-grow]) .card-wrapper {
    height:100%;
}
  :host([site='GHS']) .card-wrapper {
    display:flex;
}
  :host([site='GHS']) .card-wrapper {
    width:100%;
}
  :host([site='GHS']) .card-wrapper {
    flex:1 1 0%;
}
  :host([site='GHS']) .card-wrapper {
    flex-direction:column;
}
  :host([site='GHS']) .card-wrapper {
    align-self:stretch;
}
  :host([site='GHS']) .card-wrapper {
    background-color:var(--neutral-white);
}
  :host([site='GHS']) .card {
    display:flex;
}
  :host([site='GHS']) .card {
    height:100%;
}
  :host([site='GHS']) .card {
    flex-direction:column;
}
  :host([site='GHS']) img {
    margin-bottom:2.75rem;
}
  :host([site='GHS']) img {
    border-radius:1rem;
}
  :host([site='GHS']) img {
    object-fit:cover;
}
  :host([site='GHS']) img{
    height:218px !important;

    box-shadow:var(--brand-shadow);
  }
  :host([site='GHS']) .card-body-wrapper {
    display:flex;
}
  :host([site='GHS']) .card-body-wrapper {
    flex-grow:1;
}
  :host([site='GHS']) .card-body-wrapper {
    flex-direction:column;
}
  :host([site='GHS']) .card-eyebrow {
    margin-bottom:0.5rem;
}
  :host([site='GHS']) .card-eyebrow {
    font-family:var(--ff-body);
}
  :host([site='GHS']) .card-eyebrow {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
}
  :host([site='GHS']) .card-eyebrow {
    font-weight:var(--fw-normal);
}
  :host([site='GHS']) .card-eyebrow {
    text-transform:uppercase;
}
  :host([site='GHS']) .card-eyebrow {
    color:var(--neutral-gray-1);
}
  :host([site='GHS']) .card-heading {
    margin-bottom:0.75rem;
}
  :host([site='GHS']) .card-heading {
    font-family:var(--ff-display);
}
  :host([site='GHS']) .card-heading {
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
}
  :host([site='GHS']) .card-heading {
    font-weight:var(--fw-bold);
}
  :host([site='GHS']) .card-heading {
    color:var(--primary-blue-light-2);
}
  :host([site='GHS']) .card-subheading {
    margin-bottom:0.5rem;
}
  :host([site='GHS']) .card-subheading {
    font-weight:var(--fw-semibold);
}
  :host([site='GHS']) .card-content {
    flex-grow:1;
}
  :host([site='GHS']) .card-content {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
}
  :host([site='GHS']) .card-cta {
    margin-top:1.25rem;
}
  :host([site='GHS']) .card-cta {
    font-family:var(--ff-display);
}
  :host([site='GHS']) .card-cta {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
}
  :host([site='GHS']) .card-cta {
    font-weight:var(--fw-bold);
}
  :host([site='GHS']) .card-icon {
    position:absolute;
}
  :host([site='GHS']) .card-icon {
    top:8.5rem;
}
  :host([site='GHS']) .card-icon {
    right:2.75rem;
}
  :host([site='GHS']) .card-icon {
    display:flex;
}
  :host([site='GHS']) .card-icon {
    height:7rem;
}
  :host([site='GHS']) .card-icon {
    width:7rem;
}
  :host([site='GHS']) .card-icon {
    align-items:center;
}
  :host([site='GHS']) .card-icon {
    justify-content:center;
}
  :host([site='GHS']) .card-icon {
    border-radius:9999px;
}
  :host([site='GHS']) .card-icon {
    background-color:var(--neutral-white);
}
  :host([site='GHS']) .card-icon {
    color:var(--primary-blue);
}
  :host([site='GHS']) .card-icon{

    box-shadow:var(--brand-shadow);
  }
  :host([site='GHS']):host([sideways]) {
    overflow:hidden;
}
  :host([site='GHS']):host([sideways]) {
    border-radius:0.75rem;
}
  :host([site='GHS']):host([sideways]) {
    padding:0px;
}
  :host([site='GHS']):host([sideways]){
    box-shadow:var(--brand-shadow);
  }
  :host([site='GHS']):host([sideways]) .card-wrapper {
    min-height:240px;
}
  :host([site='GHS']):host([sideways]) .card-wrapper {
    background-color:var(--neutral-white);
}
  :host([site='GHS']):host([sideways]):host([bg-color='green']) .card-wrapper {
    background-color:var(--primary-green);
}
  :host([site='GHS']):host([sideways]):host([bg-color='blue']) .card-wrapper {
    background-color:var(--primary-blue);
}
  :host([site='GHS']):host([sideways]):host([bg-color='white']) .card-icon {
    color:var(--primary-blue);
}
  :host([site='GHS']):host([sideways]) .card-icon {
    top:4rem;
}
  :host([site='GHS']):host([sideways]) .card-icon {
    left:50%;
}
  :host([site='GHS']):host([sideways]) .card-icon {
    height:100px;
}
  :host([site='GHS']):host([sideways]) .card-icon {
    width:100px;
}
  :host([site='GHS']):host([sideways]) .card-icon {
    --tw-translate-x:-50%;
    transform:translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  :host([site='GHS']):host([sideways]) .card-icon {
    --tw-translate-y:0px;
    transform:translate(var(--tw-translate-x), 0px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  :host([site='GHS']):host([sideways]) .card-icon {
    background-color:var(--neutral-transparent);
}
  :host([site='GHS']):host([sideways]) .card-icon {
    color:var(--neutral-white);
}
  :host([site='GHS']):host([sideways]) .card-icon {
    --tw-shadow:0 0 #0000;
    --tw-shadow-colored:0 0 #0000;
    box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
    box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  @media (min-width: 768px) {
    :host([site='GHS']):host([sideways]) .card-icon {
        top:50%;
    }
}
  @media (min-width: 768px) {
    :host([site='GHS']):host([sideways]) .card-icon {
        left:70px;
    }
}
  @media (min-width: 768px) {
    :host([site='GHS']):host([sideways]) .card-icon {
        --tw-translate-x:0px;
        transform:translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
        transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }
}
  @media (min-width: 768px) {
    :host([site='GHS']):host([sideways]) .card-icon {
        --tw-translate-y:-50%;
        transform:translate(var(--tw-translate-x), -50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
        transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }
}
  @media (min-width: 1024px) {
    :host([site='GHS']):host([sideways]) .card-icon {
        left:54px;
    }
}
  @media (min-width: 1280px) {
    :host([site='GHS']):host([sideways]) .card-icon {
        left:70px;
    }
}
  :host([site='GHS']):host([sideways]) .card-body-wrapper {
    margin-top:14rem;
}
  :host([site='GHS']):host([sideways]) .card-body-wrapper {
    background-color:var(--neutral-white);
}
  :host([site='GHS']):host([sideways]) .card-body-wrapper {
    padding:1.5rem;
}
  @media (min-width: 768px) {
    :host([site='GHS']):host([sideways]) .card-body-wrapper {
        margin-left:15rem;
    }
}
  @media (min-width: 768px) {
    :host([site='GHS']):host([sideways]) .card-body-wrapper {
        margin-top:0px;
    }
}
  @media (min-width: 1024px) {
    :host([site='GHS']):host([sideways]) .card-body-wrapper {
        margin-left:13rem;
    }
}
  @media (min-width: 1280px) {
    :host([site='GHS']):host([sideways]) .card-body-wrapper {
        margin-left:15rem;
    }
}

:host {
    position:relative;
    display:flex;
    height:100%;
    padding-bottom:1rem;
    transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration:300ms;
}

:host([site='BH']) :host([height-grow]) {
    display:block;
}

:host([site='BH']) :host([height-grow]) {
    height:100%;
}

:host([site='BH']) :host([height-grow]) .card, :host([site='BH']) :host([height-grow]) .card-wrapper {
    height:100%;
}

:host([site='BH']) .card-wrapper {
    display:flex;
}

:host([site='BH']) .card-wrapper {
    width:100%;
}

:host([site='BH']) .card-wrapper {
    flex:1 1 0%;
}

:host([site='BH']) .card-wrapper {
    flex-direction:column;
}

:host([site='BH']) .card-wrapper {
    align-self:stretch;
}

:host([site='BH']) .card-wrapper {
    background-color:var(--neutral-white);
}

:host([site='BH']) .card {
    display:flex;
}

:host([site='BH']) .card {
    height:100%;
}

:host([site='BH']) .card {
    flex-direction:column;
}

:host([site='BH']) img {
    margin-bottom:2.75rem;
}

:host([site='BH']) img {
    object-fit:cover;
}

:host([site='BH']) img{
    height:218px !important;

    box-shadow:var(--brand-shadow);
  }

:host([site='BH']) .card-body-wrapper {
    display:flex;
}

:host([site='BH']) .card-body-wrapper {
    flex-grow:1;
}

:host([site='BH']) .card-body-wrapper {
    flex-direction:column;
}

:host([site='BH']) .card-eyebrow {
    margin-bottom:0.5rem;
}

:host([site='BH']) .card-eyebrow {
    font-family:var(--ff-body);
}

:host([site='BH']) .card-eyebrow {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
}

:host([site='BH']) .card-eyebrow {
    font-weight:var(--fw-normal);
}

:host([site='BH']) .card-eyebrow {
    text-transform:uppercase;
}

:host([site='BH']) .card-eyebrow {
    color:var(--neutral-gray-1);
}

:host([site='BH']) .card-heading {
    flex:none;
}

:host([site='BH']) .card-heading {
    flex-grow:0;
}

:host([site='BH']) .card-heading {
    align-self:stretch;
}

:host([site='BH']) .card-heading {
    font-family:var(--bh-ff-display);
}

:host([site='BH']) .card-heading {
    font-size:var(--bh-fs-heading-04);
    line-height:var(--bh-lh-heading-04);
    letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) .card-heading {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
}

:host([site='BH']) .card-heading {
    color:var(--bh-neutral-black);
}

:host([site='BH']) .card-subheading {
    margin-bottom:0.5rem;
}

:host([site='BH']) .card-subheading {
    font-weight:var(--fw-semibold);
}

:host([site='BH']) .card-content {
    order:1;
}

:host([site='BH']) .card-content {
    margin-top:0.5rem;
}

:host([site='BH']) .card-content {
    flex:none;
}

:host([site='BH']) .card-content {
    flex-grow:1;
}

:host([site='BH']) .card-content {
    align-self:stretch;
}

:host([site='BH']) .card-content {
    font-size:var(--bh-fs-body-02);
    line-height:var(--bh-lh-body-02);
    letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) .card-content {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
}

:host([site='BH']) .card-cta {
    order:2;
}

:host([site='BH']) .card-cta {
    margin-top:0.75rem;
}

:host([site='BH']) .card-cta {
    flex:none;
}

:host([site='BH']) .card-cta {
    flex-grow:0;
}

:host([site='BH']) .card-icon {
    position:absolute;
}

:host([site='BH']) .card-icon {
    top:8.5rem;
}

:host([site='BH']) .card-icon {
    right:2.75rem;
}

:host([site='BH']) .card-icon {
    display:flex;
}

:host([site='BH']) .card-icon {
    height:7rem;
}

:host([site='BH']) .card-icon {
    width:7rem;
}

:host([site='BH']) .card-icon {
    align-items:center;
}

:host([site='BH']) .card-icon {
    justify-content:center;
}

:host([site='BH']) .card-icon {
    border-radius:9999px;
}

:host([site='BH']) .card-icon {
    background-color:var(--neutral-white);
}

:host([site='BH']) .card-icon {
    color:var(--bh-brand-primary-default);
}

:host([site='BH']) .card-icon{

    box-shadow:var(--brand-shadow);
  }
`;